import { render, staticRenderFns } from "./view-group.vue?vue&type=template&id=27727430&"
import script from "./view-group.vue?vue&type=script&lang=js&"
export * from "./view-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports